<template>
  <footer class="footer">
    <div class="max-width">
      <div class="footer__grid">
        <div class="footer__about">
          <div class="footer__logo"><img src="@/assets/imgs/logo-white.svg" alt="Creative Commerce Labs white logo "></div>

          <div class="footer__sub">
            <div class="footer__sub-label">Be the First to Know</div>
            <div class="footer__sub-note">Get early access to our newest Shopify themes, feature releases, and updates, plus practical how-to guides to help you get more from your store — directly to your inbox.</div>

            <SubformView/>
          </div>
        </div>

        <div class="footer__nav">
          <div class="footer__column">
            <div class="footer__label">Sitemap</div>
            <div class="footer__menu">
              <router-link to="/themes">Themes</router-link>
              <router-link to="/contacts">Contacts</router-link>
              <router-link to="/help-center">Help Center</router-link>
            </div>
          </div>
          <div class="footer__column">
            <div class="footer__label">Legal</div>
            <div class="footer__menu">
              <router-link to="/privacy">Privacy Policy</router-link>
              <router-link to="/terms">Terms & Conditions</router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="footer__bottom">
        <div class="footer__copy">Copyright © All Rights Reserved.</div>
        <div class="footer__top js--top">
          <IconUp />
        </div>
      </div>
    </div>
  </footer>
</template>

<style lang="scss">
  .footer {
    background:#000;

    &__grid {
      padding:4rem 0 5.625rem;
      display:flex;
      justify-content:space-between;

      @include md {
        flex-direction:column;
        padding:3rem 0;
        gap:3rem;
      }
    }

    &__about {
      max-width:570px;
      width:100%;
    }

    &__logo {
      margin:0 0 5.625rem;

      @include xs {
        margin:0 0 3.5rem;
      }
    }

    &__sub {
      &-label {
        margin:0 0 1rem;
        font-weight: 500;
        font-size: 1rem;
        color:#fff;
        line-height: 1.38;
      }

      &-note {
        font-size:.875rem;
        font-weight:500;
        line-height:1.4;
        color:#fff;
        opacity:.7;
        margin:0 0 1.5rem;
        max-width:450px;
      }
    }

    &__nav {
      display:flex;
      color:#fff;
      gap:108px;

      @include md {
        gap:4rem;
      }
    }

    &__label {
      margin:0 0 1rem;
      font-size:.75rem;
    }

    &__menu {
      display:flex;
      flex-direction:column;
      gap:.5rem;

      a {
        color:#fff;
        display:block;

        &:hover, &.router-link-active {
          opacity:.7;
        }
      }
    }

    &__bottom {
      border-top:1px solid rgba(97,97,97,.2);
      padding:1.5rem 0 1.7rem;
      display:flex;
      align-items:center;
      justify-content:space-between;
    }

    &__copy {
      font-size: .75rem;
      color:var(--color-gray-light);
    }

    &__top {
      margin:auto 0;
      width:2.5rem;
      height:2.5rem;
      display:flex;
      align-items:center;
      justify-content:center;
      cursor:pointer;
      user-select:none;
      border-radius:12px;
      transition:var(--transition);
      background:var(--color-accent);

      svg {
        transition:var(--transition);
      }

      &:hover {
        background:#fff;

        svg {
          filter:brightness(0) invert(0);
          transform:translateY(-3px);
        }
      }
    }
  }
</style>

<script setup>
  import IconUp from '@/components/icons/IconUp.vue'
  import SubformView from '@/components/SubformView.vue'
</script>
